import React, { useEffect, useState } from 'react';
import { fetchCMSContent } from '../lib/cms';
import { Clock, Tag } from 'lucide-react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export default function Services() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadServices = async () => {
      const data = await fetchCMSContent('services');
      setServices(data);
      setLoading(false);
    };
    loadServices();
  }, []);

  if (loading) return (
    <section id="behandlinger" className="py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 text-center">
        <div className="animate-pulse flex flex-col items-center">
          <div className="h-8 w-48 bg-stone-200 rounded mb-4"></div>
          <div className="h-4 w-64 bg-stone-200 rounded mb-12"></div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 w-full">
            {[1, 2, 3, 4].map(i => (
              <div key={i} className="h-80 bg-stone-200 rounded-2xl"></div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: "easeOut"
      }
    }
  };

  const displayLimit = 2;

  return (
    <section id="behandlinger" className="py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl sm:text-4xl font-prata font-medium text-stone-900 mb-4 uppercase tracking-tight">Vores Behandlinger</h2>
          <p className="text-lg text-stone-600 max-w-2xl mx-auto">
            Vi tilbyder en række forskellige massageformer og ansigtsbehandlinger, der alle har til formål at give dig fysisk og mentalt velvære.
          </p>
        </motion.div>

        <motion.div 
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-2 gap-8"
        >
          {services.slice(0, 2).map((service) => (
            <motion.div 
              key={service.id} 
              variants={itemVariants}
              className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 flex flex-col justify-between"
            >
              <div>
                <div className="flex justify-between items-start mb-4">
                  <h4 className="text-xl font-prata font-medium text-stone-900 uppercase tracking-wide">{service.title.da}</h4>
                  <span className="text-black font-bold text-lg whitespace-nowrap ml-4">{service.price} kr.</span>
                </div>
                <div 
                  className="text-stone-600 mb-6 prose prose-sm max-w-none"
                  dangerouslySetInnerHTML={{ __html: service.description.da }}
                />
              </div>
              <div className="flex items-center text-sm text-stone-500 gap-4 mt-auto pt-6 border-t border-stone-50">
                <div className="flex items-center">
                  <Clock className="w-4 h-4 mr-1 text-stone-400" />
                  {service.duration.da}
                </div>
                <div className="flex items-center">
                  <Tag className="w-4 h-4 mr-1 text-stone-400" />
                  {service.category?.da || 'Massage'}
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>

        {services.length > displayLimit && (
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="mt-16 text-center"
          >
            <Link 
              to="/priser"
              className="inline-block bg-[#ffbd59] text-white px-10 py-4 rounded-full font-medium uppercase tracking-[0.2em] hover:bg-[#eeb050] transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
            >
              Se alle behandlinger og priser
            </Link>
          </motion.div>
        )}
      </div>
    </section>
  );
}
